import { connect } from 'react-redux';
import { pathOr } from 'ramda';

import { IState } from '../../store';
import { isABAgentExperienceExperiment } from '../../utils/ab_agent_experience';
import { AuthorAsideBrand, IAuthorAsideBrandProps } from './index';
import { showCountrysideBuilderBadge } from '../../utils/suburban';

export function mapStateToProps(state: IState): IAuthorAsideBrandProps {
  return {
    agent: state.offerData.agent,
    agentReviews: state.offerData.agentReviews,
    developer: state.offerData.newObject && state.offerData.newObject.developer,
    isAgentExperienceExperimentActive: isABAgentExperienceExperiment(state.experiments),
    companyFoundationTime: pathOr(null, ['offerData', 'company', 'yearFoundation'], state),
    offer: state.offerData.offer,
    showCountrysideBuilderBadge: showCountrysideBuilderBadge(state),
  };
}

export const AuthorAsideBrandContainer = connect(
  mapStateToProps,
)(AuthorAsideBrand);
